import React from "react";
import Select from 'react-select'

const KeySelector = props => {

  if (props.gameType === 'frets') {
    return (
      <table className="key-selector" valign="top" border="0">
        <thead><tr><th align="left">Key</th></tr></thead>
        <tbody>
          <tr>
            <td></td>
          </tr>
        </tbody>
      </table>
    )
  }

  const flatSign  = String.fromCharCode(0x266d)
  const sharpSign = String.fromCharCode(0x266f)

  const keys = [
    { value: 'any',    label: 'ANY' },
    { value: 'cflat',  label: 'C' + flatSign },
    { value: 'gflat',  label: 'G' + flatSign },
    { value: 'dflat',  label: 'D' + flatSign },
    { value: 'aflat',  label: 'A' + flatSign },
    { value: 'eflat',  label: 'E' + flatSign },
    { value: 'bflat',  label: 'B' + flatSign },
    { value: 'f',      label: 'F' },
    { value: 'c',      label: 'C' },
    { value: 'g',      label: 'G' },
    { value: 'd',      label: 'D' },
    { value: 'a',      label: 'A' },
    { value: 'e',      label: 'E' },
    { value: 'b',      label: 'B' },
    { value: 'fsharp', label: 'F' + sharpSign },
    { value: 'csharp', label: 'C' + sharpSign },
  ];

  function optionFromKee() {
    if (props.kee === 'any'   ) return { value: 'any',    label: 'ANY' };
    if (props.kee === 'cflat' ) return { value: 'cflat',  label: 'C' + flatSign };
    if (props.kee === 'gflat' ) return { value: 'gflat',  label: 'G' + flatSign };
    if (props.kee === 'dflat' ) return { value: 'dflat',  label: 'D' + flatSign };
    if (props.kee === 'aflat' ) return { value: 'aflat',  label: 'A' + flatSign };
    if (props.kee === 'eflat' ) return { value: 'eflat',  label: 'E' + flatSign };
    if (props.kee === 'bflat' ) return { value: 'bflat',  label: 'B' + flatSign };
    if (props.kee === 'f'     ) return { value: 'f',      label: 'F' };
    if (props.kee === 'c'     ) return { value: 'c',      label: 'C' };
    if (props.kee === 'g'     ) return { value: 'g',      label: 'G' };
    if (props.kee === 'd'     ) return { value: 'd',      label: 'D' };
    if (props.kee === 'a'     ) return { value: 'a',      label: 'A' };
    if (props.kee === 'e'     ) return { value: 'e',      label: 'E' };
    if (props.kee === 'b'     ) return { value: 'b',      label: 'B' };
    if (props.kee === 'fsharp') return { value: 'fsharp', label: 'F' + sharpSign };
    if (props.kee === 'csharp') return { value: 'csharp', label: 'C' + sharpSign };
    return { value: 'c',      label: 'C' };
  };

  return (
    <table className="key-selector" valign="top" border="0">
      <thead><tr><th align="left">Key</th></tr></thead>
      <tbody>
        <tr>
          <td>
            <Select
              className="key-selector"
              defaultValue={optionFromKee()}
              options={keys}
              onChange={selection => props.callbacks.keeSetter(selection.value)}
            />
          </td>
        </tr>
      </tbody>
    </table>
  )

};

export default KeySelector;






